import { Box, IconButton, Stack, Typography } from "@mui/material"
import { colours } from "../../../StyleConstants"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useGetDataProvidersQuery } from "../../../api/dataProvidersApiSlice";

const boxStyles = {
    backgroundColor: colours.core.white,
    boxShadow: "1px 2px 5px 0px #1518181A",
    padding: 3,
}

const shellCommand = "$ cat mykey.txt | ssh user@host “mkdir  -p  ~/.ssh  &&  chmod 700  ~/ssh  &&  cat >>  ~/.ssh/authorized_keys”";

const ConfigurationInformation = () => {
    const { data } = useGetDataProvidersQuery({});
    const sshKey = data?.meta?.public_key || "";
    return (
        <Stack gap={3}>
            <Typography fontWeight={600} fontSize="24px">Configuration Information</Typography>
            <Typography fontSize="14px">
                A public SSH key needs to be added to the authorized keys of the user on the host. Paste the SSH key below in a text file then use the following command to add it to the “authorized_keys” file on the host
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} sx={boxStyles}>
                <Box>
                    <Typography fontWeight={600} fontSize="14px">Command Line</Typography>
                    <Typography fontSize="14px">
                        {shellCommand}
                    </Typography>
                </Box>
                <IconButton onClick={() => navigator.clipboard.writeText(shellCommand)}>
                    <ContentCopyIcon />
                </IconButton>

            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} sx={boxStyles}>
                <Box>
                    <Typography fontWeight={600} fontSize="14px">Public SSH key</Typography>
                    <Typography sx={{ wordBreak: "break-all" }} fontSize="14px">
                        {sshKey}
                    </Typography>
                </Box>
                <IconButton onClick={() => navigator.clipboard.writeText(sshKey)}>
                    <ContentCopyIcon />
                </IconButton>

            </Stack>
        </Stack >
    )
}

export default ConfigurationInformation